import { Outlet } from "react-router-dom";
import Header from "../header";

export default function CleanLayout(){


    return (
        <>
            <Header/>
            <Outlet/>
        
        </>
    )

}





